import { Grid } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";
import { useLocation } from "react-router-dom";

const HomeServices = ({ isMobile }) => {
  const location = useLocation();

  const handleWhatsApp = () => {
    trackEvent("contactanos_home", {
      page_path: location.pathname,
      page_url: window.location.href,
      section: "servicios a domicilio",
      cta_name: "enviar_mensaje",
      value: 1,
    });

    openWhatsApp(
      "525514772163",
      `Hola MoviCare 👋, Me gustaria cotizar algunos servicios a domicilio.`,
      true,
    );
  };
  return (
    <Grid container sx={design.Direction}>
      <CustomText
        variant="subtitle1"
        color="#000"
        text="Donde la familia es nuestra prioridad"
        sx={design.Title}
      >
        Servicios a domicilio
      </CustomText>

      <Grid container width="100%" mt={2}>
        <Grid size={design.Grid1} />
        <Grid size={design.Grid4} alignSelf="center">
          <CustomText
            variant="subtitle1"
            color="#000"
            text="Donde la familia es nuestra prioridad"
            sx={design.TextTitulo}
          >
            Estudios de Laboratorio
          </CustomText>
          <CustomText
            variant="subtitle1"
            color="#000"
            text="Donde la familia es nuestra prioridad"
            sx={design.Description}
          >
            En MEDAM sabemos que hay cuidados que pueden resolverse desde casa.
            Por eso, nos aliamos con <strong>MoviCare Servicios Médicos</strong>{" "}
            para acercarte atención médica de calidad sin que tengas que salir.
            <br />
            <br />
            Realizamos{" "}
            <strong>
              estudios de laboratorio, rayos X y traslados de pacientes
            </strong>{" "}
            con el mismo compromiso, calidez y profesionalismo que nos
            caracteriza. Porque en MEDAM creemos en una atención integral, estés
            donde estés.
          </CustomText>
          <CustomButton
            type="submit"
            variant="contained"
            color="success"
            colorTexto="#FFF"
            backgroundColor="#2349D0"
            width={isMobile ? "100%" : "70%"}
            height={50}
            grid={12}
            gridXS={12}
            borderRadius={10}
            style={design.Button}
            onClick={handleWhatsApp}
          >
            Contactanos
            <WhatsApp />
          </CustomButton>
        </Grid>
        <Grid item size={design.Grid11} />
        <Grid item size={design.Grid11} />
        <Grid size={design.Grid5} pt={isMobile ? 2 : 0}>
          <ImageLoader
            src="https://centromedicomedam.com/IMG/centromedicoMEDAM/servicios_a_domicilio_con_el_centro_medico_MEDAM.png"
            alt="servicios_a_domicilio_con_el_centro_medico_MEDAM"
            width="99%"
            height={isMobile ? 250 : 433}
          />
        </Grid>
        <Grid size={design.Grid1} />
      </Grid>
    </Grid>
  );
};

export default HomeServices;

const design = {
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 28,
      sm: 34,
      md: 42,
      lg: 45,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "1%",
    textAlign: "center",
  },
  Direction: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 5,
  },
  Grid: {
    display: "flex",
    justifyContent: "flex-end",
    paddingRight: 5,
  },
  TextTitulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 22,
      sm: 34,
      md: 30,
      lg: 30,
    },
    fontWeight: 700,
    textAlign: "left",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 15,
      sm: 15,
      md: 18,
      lg: 18,
    },
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "left",
    paddingRight: 5,
  },
  Button: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 15,
      sm: 15,
      md: 18,
      lg: 18,
    },
    marginTop: "3%",
  },
  WhatsApp: { fontSize: 40, color: "#489E4D" },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid11: { xs: 1, md: 0, xl: 0, lg: 0 },
  Grid4: { xs: 10, md: 4, xl: 4, lg: 4 },
  Grid5: { xs: 10, md: 6, xl: 6, lg: 6 },
};
